export default __webpack_public_path__ + "static/media/074.8a009c66.jpeg";